// eslint-disable-next-line import/no-extraneous-dependencies
import flatten from 'flat';
import { match } from 'path-to-regexp';

import { webappRoutes } from '../constants/routes';

const supportedLanguages = ['fr', 'en'];

const routesMatcher = new Map();

export default function getWebAppRouteKey(path, routesList = webappRoutes) {
  const isHomepage = supportedLanguages.some((lang) => path === `/${lang}`);
  const cleanPath = isHomepage
    ? '/'
    : path.replace(new RegExp(`^/(${supportedLanguages.join('|')})/`), '/').split('?')[0];
  let routeKey;

  Object.entries(flatten(routesList)).forEach(([key, value]) => {
    if (!routesMatcher.has(key)) {
      routesMatcher.set(key, match(value, { decode: decodeURIComponent }));
    }

    const result = routesMatcher.get(key)(cleanPath);

    if (result) {
      routeKey = key;
    }
  });

  return routeKey;
}
